var SnowChainsJs = (function ($) {

    var removeSelectBoxesContent = function( selectBoxList ){
        for(var selectBoxId in selectBoxList){
            var selectBox = $(selectBoxList[selectBoxId]);
            selectBox.find('option:gt(0)').remove();
            selectBox.prop('disabled', true);
            $(selectBoxList[selectBoxId]+' option:first-child').prop("selected", true);
        }
    };

    var displayErrorDiv = function(){
        $(".snow-chain-error-div").show();
    };

    var addHandlers = function() {
       addWidthSelectorHandler();
       addProfileSelectorHandler();
       addSizeSelectorHandler();
    };

    var addWidthSelectorHandler = function(){
        $('#snow-chains-width-select').on('change',function() {
                var widthValue = $("#snow-chains-width-select option:selected").val();
                removeSelectBoxesContent(['#snow-chains-profile-select','#snow-chains-size-select']);
                $("#snow-chains-default-submit").prop('disabled', true);
                $.ajax({
                    type : 'GET',
                    url : "/snow-chains/profiles/search?width=" + widthValue,
                    success : function(data) {
                        if (data){
                            $("#snow-chains-profile-select").prop('disabled',false).trigger("focus");
                            for ( var i in data) {
                                $("#snow-chains-profile-select").append(
                                                        "<option value='" + data[i] + "'>" + data[i]+"</option>");
                            }
                            $("#snow-chains-profile-select").trigger("change");
                        }
                    },
                    error : function(xhr, ajaxOptions, thrownError) {
                       displayErrorDiv();
                    }
                });
            }
        );
    }

    var addProfileSelectorHandler= function() {
        $('#snow-chains-profile-select').on('change',function() {
            var widthValue = $("#snow-chains-width-select option:selected").val();
            var profileValue = $("#snow-chains-profile-select option:selected").val();
            removeSelectBoxesContent(['#snow-chains-size-select']);
            $("#snow-chains-default-submit").prop('disabled', true);
            $.ajax({
                type : 'GET',
                url : "/snow-chains/sizes/search?width=" + widthValue+"&profile="+ profileValue,
                success : function(data) {
                    if (data){
                        $("#snow-chains-size-select").prop('disabled', false)
                                .trigger("focus");
                        for ( var i in data) {
                            $("#snow-chains-size-select").append(
                                    "<option value='" + data[i] + "'>" + "R" + data[i]+"</option>");
                        }
                        $("#snow-chains-size-select").trigger("change");
                    }
                },
                error : function(xhr, ajaxOptions, thrownError) {
                    displayErrorDiv();
                }
            });
          }
        );
     };

     var addSizeSelectorHandler= function() {

         $('#snow-chains-size-select').on('change',function() {
                  if (this.value != '') {
                      $("#snow-chains-default-submit").prop('disabled', false);
                  } else{
                      $("#snow-chains-default-submit").prop('disabled', true);
                  }
              }
         );
      };

    var bindAddToCart = function (sel) {
        if (!$(sel).length){
            return;
        }

        $(document).on("submit", sel, function(event){
            event.preventDefault();
            var $form = $(event.target);
            var url = $form.attr('action');
            var token = $("input[name='_csrf']").val();
            var code = $form.find("input[name=id]").val();
            var quantity = $form.find("input[name=quantity]").val();
            var header = "X-CSRF-TOKEN";
            var productCartData = {
                "items": [{ "code": code, "quantity": quantity }],
                "price": '',
                "discountedPrice": ''
            };

            $.ajax({
                url: url,
                type: "POST",
                data: $form.serialize(),
                beforeSend: function(xhr) {
                    xhr.setRequestHeader(header, token);
                },
                success: function() {
                    $( document ).trigger( "changeCartEvent", productCartData);
                }
            });
        });
    };

return {
        addHandlers:addHandlers,
        bindAddToCart:bindAddToCart
    }
}) (jQuery);

$(document).ready(function() {
    if ( $('#snow-chains-width-select').length ) {
        SnowChainsJs.addHandlers();
    }

    if ($('form.snow-chain-to-cart-form').length) {
        SnowChainsJs.bindAddToCart("form.snow-chain-to-cart-form");
    }

});